
























































import {
  Vue, Component, Prop, PropSync,
} from 'vue-property-decorator';
import { PartnersApi } from '@compassdigital/foodworks.ts.sdk';
import AppModule from '@/store/modules/app';
import UserModule from '@/store/modules/user';
import PartnerUtil from '@/util/PartnerUtil';
import Service from '@/util/ServiceUtil';
import ToastModule from '@/store/modules/toast';
import FirstCheckBox from '@/components/Selection/FirstCheckBox/index.vue';

@Component({
  components: {
    FirstCheckBox,
  },
})
export default class PartnersList extends Vue {
  @Prop() public search!: string;

  @Prop() public searchMarket!: any;

  @Prop() public searchScout!: any;

  @Prop() public searchStatus!: any;

  @Prop() public searchCuisine!: any;

  @Prop() public searchType!: any;

  @PropSync('markets') marketsSync!: any;

  @PropSync('scouts') scoutsSync!: any;

  @Prop({ default: false }) public marketsLoaded!: boolean;

  @Prop({ default: false }) public scoutsLoaded!: boolean;

  @PropSync('deleteIcon') deleteIconSync!: any;

  @PropSync('restaurantPartners') selectedRP!: any;

  @PropSync('partnerArr') partnerArrSync!: any;

  @PropSync('checkPartnerValue') checkPartnerValueSync!: any;

  public blankArr: any[] = [];

  public loading: boolean = false;

  public errors: string = '';

  private partners: any[] = [];

  private headers = [
    {
      text: '',
      align: 'center',
      value: 'checkbox',
      width: '30px',
    },
    {
      text: 'Restaurant',
      align: 'left',
      value: 'partnerName',
      width: '250px',
    },
    {
      text: 'Market',
      align: 'left',
      value: 'marketName',
      width: '200px',
    },
    {
      text: 'FW Employee',
      align: 'left',
      value: 'scoutName',
      width: '200px',
    },
    {
      text: 'Partner Type',
      align: 'left',
      value: 'type',
      width: '160px',
    },
    {
      text: 'Activation Status',
      align: 'right',
      value: 'status',
      width: '180px',
    },
  ];

  get filteredItems() {
    if (this.checkPartnerValueSync) {
      this.getPartners();
      this.checkPartnerValueSync = false;
    }
    let filteredPartners = this.partners;
    if (this.search) {
      filteredPartners = filteredPartners.filter(
        partner => (partner.partnerName).toLowerCase()
          .includes(this.search.toLowerCase())
        || (partner.status)
          .toLowerCase()
          .includes(this.search.toLowerCase())
        || (partner.marketName)
          .toLowerCase()
          .includes(this.search.toLowerCase())
        || (partner.scoutName)
          .toLowerCase()
          .includes(this.search.toLowerCase())
        || (partner.type)
          .toLowerCase()
          .includes(this.search.toLowerCase()),
      );
    }
    if (this.searchMarket && this.searchMarket.length > 0) {
      filteredPartners = filteredPartners.filter(
        partner => this.searchMarket.includes(partner.marketID),
      );
    }
    if (this.searchScout && this.searchScout.length > 0) {
      filteredPartners = filteredPartners.filter(
        partner => this.searchScout.includes(partner.scoutID),
      );
    }
    if (this.searchStatus && this.searchStatus.length > 0) {
      filteredPartners = filteredPartners.filter(
        partner => this.searchStatus.includes(partner.status),
      );
    }
    if (this.searchCuisine && this.searchCuisine.length > 0) {
      filteredPartners = filteredPartners.filter(
        partner => this.searchCuisine.includes(partner.cuisineType),
      );
    }
    if (this.searchType && this.searchType.length > 0) {
      filteredPartners = filteredPartners.filter(
        partner => this.searchType.includes(partner.type),
      );
    }
    if (this.partnerArrSync.length === 0) {
      this.deleteIconSync = false;
      this.selectedRP = [];
    }
    return filteredPartners;
  }

  private waitForScouts(): Promise<void> {
    return new Promise((resolve) => {
      const isReady = () => this.marketsLoaded && this.scoutsLoaded;

      if (isReady()) {
        resolve();
        return;
      }

      let done = false;
      let timeoutId: ReturnType<typeof setTimeout>;
      let unwatch: () => void;

      const finish = () => {
        if (done) return;
        done = true;
        clearTimeout(timeoutId);
        unwatch();
        resolve();
      };

      unwatch = this.$watch(
        () => [this.marketsLoaded, this.scoutsLoaded],
        () => {
          if (isReady()) finish();
        },
      );

      timeoutId = setTimeout(finish, 19000);
    });
  }

  public mounted() {
    this.getPartners();
    if (this.$route.params.message) {
      ToastModule.setToast({
        message: this.$route.params.message,
        timeout: 2000,
      });
    }
  }

  public async getPartners() {
    try {
      this.loading = true;
      await this.waitForScouts();
      if (AppModule.isLoggedIn && AppModule.accessToken) {
        try {
          const api = new PartnersApi(AppModule.apiConfig);
          const partners: any = await api.getPartners(undefined, { params: { type: 'partners' } });
          this.partners = PartnerUtil.getMappedPartners(
            partners.data,
            this.marketsSync,
            UserModule.formattedFullname,
            this.scoutsSync,
          );
        } catch (err) {
          throw err;
        }
      }
    } catch (err) {
      if (err.error) {
        this.errors = err.error;
      }
    }
    this.loading = false;
  }

  public onClickCheckbox(event: any) {
    if (event.target.checked === true) {
      this.selectedRP.push(event.target.value);
      if (this.selectedRP.length > 0) {
        this.deleteIconSync = true;
      }
    }
    if (event.target.checked === false) {
      const id = event.target.value;
      this.selectedRP = this.selectedRP.filter((item: any) => item !== id);
      if (this.selectedRP.length === 1) {
        this.deleteIconSync = false;
      }
    }
  }

  public onClickRow(item: any) {
    if (item) {
      const { id } = item;
      this.$router.push({ name: 'partner-detail', params: { id } });
    }
  }

  public get approverStatus() {
    const userStatus = Service.approverUser();
    if (userStatus) {
      return true;
    }
    return false;
  }
}
